'use strict';

var React = require('react');

var SvgCashRupeeMajor = function SvgCashRupeeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 10c0-5.514-4.486-10-10-10s-10 4.486-10 10 4.486 10 10 10 10-4.486 10-10zm-10.474 2.062 2.08 2.761a1 1 0 1 1-1.597 1.204l-3.009-3.993a1 1 0 0 1 1.258-1.49c.234.037.492.056.777.056.702 0 1.241-.478 1.493-1.235h-3.1a.75.75 0 1 1 0-1.5h3.229c-.09-.72-.395-1.283-.844-1.58h-2.135a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2h-.945c.233.467.38 1.004.432 1.58h.763a.75.75 0 1 1 0 1.5h-.85c-.298 1.407-1.21 2.486-2.552 2.697z"
  }));
};

exports.SvgCashRupeeMajor = SvgCashRupeeMajor;
